import { createSlice } from "@reduxjs/toolkit";

export const appTemplateSlice = createSlice({
    name: 'appTemplates',
    initialState: [],
    reducers: {
        emptyAppTemplates: () => {
            return [];
        },
        setAppTemplates: (state, action) => {
            if (Array.isArray(action?.payload)) {
                return action.payload;
            }
        },
        addAppTemplate: (state, action) => {
            return [...state, action.payload];
        },
        updateAppTemplate: (state, action) => {
            const idx = state.findIndex((p) => Number(p.id) === Number(action.payload?.id));
            if (idx !== -1) {
                state[idx] = { ...state[idx], ...action.payload };
                return state;
            } else {
                throw new Error('AppTemplate not found');
            }
        },
        removeAppTemplate: (state, action) => {
            return state.filter((t) => Number(t?.id) !== Number(action.payload?.id));
        },
    },
});

export const {
    setAppTemplates,
    emptyAppTemplates,
    addAppTemplate,
    updateAppTemplate,
    removeAppTemplate,
} = appTemplateSlice.actions;

export default appTemplateSlice.reducer;
